import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const UnProtectedRoutes = () => {
    const { isLogin } = useAuth();

    if (isLogin)
        return <Navigate to={"/profile"} />;

    return <Outlet />;
}
export default UnProtectedRoutes;